import { AxiosRequestConfig, AxiosResponse } from 'axios'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import { FsOFAOverall, FsOFAValue } from '../model/models'

export class OFAAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.getOFAValues = this.getOFAValues.bind(this)
  }

  public getOFAValues(contextModelVariantId: number, runId: number): Promise<FsOFAValue[]> {
    const endpoint = `ofa-cwi/context-variant/${contextModelVariantId}/run/${runId}`
    return this.get<FsOFAValue[]>(endpoint)
      .then((response: AxiosResponse<FsOFAValue[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  public getOFAOverall(ofaValues: FsOFAValue[]): Promise<FsOFAOverall> {
    const endpoint = 'ofa-overall-gap/calculate'
    return this.post(endpoint, ofaValues)
      .then((response: AxiosResponse) => response.data)
      .catch((error) => {
        throw error
      })
  }
}

export const ofaAPI = new OFAAPI(httpConfig)
